import React from 'react';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import { CSVLink } from 'react-csv';
import ReactToPrint from 'react-to-print';

const ConvertButtons = React.forwardRef(({ data }, ref) => {

    const convertPdf = () => {
        if (ref.current) {
            ref.current.save();
        }
    };

    return (
        <div className='flex flex-wrap mb-2 justify-center items-center gap-1 text-xs sm:text-sm '>
            <button onClick={convertPdf} className='rounded-sm bg-slate-50 hover:bg-slate-200 border-2 px-4 py-1 mr-1 animation'>Pdf
            </button>
            <ReactHtmlTableToExcel
                className='rounded-sm bg-slate-50 hover:bg-slate-200 border-2 px-4 py-1 mr-1 animation'
                filename='dashboard'
                table='table-to-xls'
                sheet='dashboard'
                buttonText='Excel'
            />
            <CSVLink
                className='rounded-sm bg-slate-50 hover:bg-slate-200 border-2 px-4 py-1 mr-1 animation hover:text-gray-700'
                data={data}
                filename="dashboard"
            >
                CSV
            </CSVLink>
            <ReactToPrint
                trigger={() => <button className='rounded-sm bg-slate-50 hover:bg-slate-200 border-2 px-4 py-1 mr-1 animation'>Print
                </button>}
                content={() => ref.current}
            />
        </div>
    )
});

export default ConvertButtons;